
import { Component, Mixins, Prop } from "vue-property-decorator";
import DashboardMixin from "@/views/dashboard/dashboard.mixin";
import { getColor } from "@/views/dashboard/dashboard.utils";
import { AlertZone } from "@/views/dashboard/dashboard.types";
import moment from "moment";
  
@Component
export default class AssessmentResult extends Mixins(DashboardMixin) {
  @Prop() assessmentResultShow!: boolean;
  @Prop() assessmentType!: string;
  @Prop() assessmentIds!: number[];
  @Prop() assessmentDates!: string[];
  @Prop() assessmentValues!: number[];
  @Prop() alertZones!: AlertZone[];
  @Prop() isAssessment!: boolean;

  loading = false;

  counter = 0;

  get assessmentDate() {
    return moment(this.assessmentDates[this.counter]).format("MM/DD/YYYY hh:mm:ss A");
  }

  get assessmentColor() {
    return getColor(this.assessmentValues[this.counter], this.alertZones, true, true);
  }

  async mounted() {
    this.loading = true;
    await this.fetchData();
    this.loading = false;
  }

  hidden(forward: boolean) {
    return forward ? this.counter == 0 : this.counter == this.assessmentIds?.length - 1;
  }

  async changeId(forward: boolean) {
    this.loading = true;
    this.counter += forward ? -1 : 1;
    await this.fetchData();
    this.loading = false;
  }

  async fetchData() {
    const fetch = [
      this.$store.dispatch("Dashboard/fetchAssessmentResults", {
        participantId: this.selectedPatientSummary.participantId, 
        clientId: this.selectedClientDDL.value,
        assessmentId: this.assessmentIds[this.counter],
        isAssessment: this.isAssessment
      })
    ];
    await Promise.all(fetch);
  }

  isSelected(answer: number, choice: number): boolean {
    return answer == choice;
  }

  closeModal() {
    this.$emit('update:assessmentResultShow', false);
  }
}
